import type { MessageKey } from '@/i18n/messages';

/**
 * A composed key's words, or `fallback` when nobody has worded that code yet.
 *
 * A missing key renders as the key itself (docs/07-Admin/Admin-App.md, rule 6);
 * where a screen can say something better — the code the API sent, or a
 * humanized form of it — this is how it notices.
 */
export function labelOr(t: (key: MessageKey) => string, key: string, fallback: string): string {
  const label = t(key as MessageKey);
  return label === key ? fallback : label;
}
